module.exports = __webpack_public_path__ + "img/bg-header.1e45cfe9.svg";